import * as React from 'react';
import { Box } from "@mui/material";
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import useStore from "../../../../store/store";
import {validPairsForOscilloscope} from "../../../../constants/constants";
import style from './durationMonitor.css';
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import FastRewindIcon from "@mui/icons-material/FastRewind";
import ReplayIcon from "@mui/icons-material/Replay";
import RefreshIcon from "@mui/icons-material/Refresh";
import FastForwardIcon from "@mui/icons-material/FastForward";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";

export default function DurationMonitorComponent() {

    const generatorOn = useStore((state) => state.generatorOn);
    const eng = useStore((state) => state.eng);
    const durationGeneratorsRegulatorValue = useStore((state) => state.durationGeneratorsRegulatorValue);
    const changeDurationGeneratorsRegulatorValue = useStore((state) => state.changeDurationGeneratorsRegulatorValue);
    const [currentIndex, setCurrentIndex] = React.useState(13);



    const handleIncrement = () => {
        if (currentIndex < validPairsForOscilloscope.length - 1) {
            setCurrentIndex(currentIndex + 1);
            changeDurationGeneratorsRegulatorValue(validPairsForOscilloscope[currentIndex + 1].duration)
        }
    };

    const handleDecrement = () => {
        if (currentIndex > 0) {
            setCurrentIndex(currentIndex - 1);
            changeDurationGeneratorsRegulatorValue(validPairsForOscilloscope[currentIndex - 1].duration)
        }
    };

    const handleReset = () => {
        setCurrentIndex(13);
        changeDurationGeneratorsRegulatorValue(validPairsForOscilloscope[13].duration);
    };

    const handleResetRight = () => {
        setCurrentIndex(0);
        changeDurationGeneratorsRegulatorValue(validPairsForOscilloscope[0].duration);
    };

    return (
        <Box sx={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
            <Box sx={{display: 'flex', flexDirection: 'column'}}>
            <Box className="monitor">
                <Box sx={{ width: '100%', position: 'absolute', textAlign: 'center', fontSize: '100%' }}>
                    {generatorOn ? durationGeneratorsRegulatorValue : null}
                </Box>
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <Box sx={{display: 'flex', marginTop: '10px'}}>
                    <button className="buttonForAmplitudeMonitor" onClick={handleReset}><KeyboardDoubleArrowLeftIcon className="buttonForAmplitudeMonitor"/></button>
                    <button className="buttonForAmplitudeMonitor" onClick={handleIncrement}><FastRewindIcon className="buttonForAmplitudeMonitor"/></button>
                    <button className="buttonForAmplitudeMonitor" onClick={handleDecrement}><FastForwardIcon className="buttonForAmplitudeMonitor"/></button>
                    <button className="buttonForAmplitudeMonitor" onClick={handleResetRight}><KeyboardDoubleArrowRightIcon className="buttonForAmplitudeMonitor"/></button>
                </Box>
            </Box>
                <Box className="textMonitor">
                    {eng ? 'DURATION' : 'ТРИВАЛІСТЬ'} t<sub style={{fontSize: 'smaller', verticalAlign: 'sub'}}><sub style={{fontSize: 'smaller', verticalAlign: 'sub'}}>i</sub></sub>, {eng ? 'ms' : 'мс'}
                </Box>
            </Box>
        </Box>
    );
};
